import { KotlinLoggingConfiguration_getInstance2afdiujdk3hao as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FormattingAppenderClass;
function FormattingAppender() {
  if (FormattingAppenderClass === VOID) {
    class $ {
      log_1olo2n_k$(loggingEvent) {
        // Inline function 'kotlin.let' call
        var it = KotlinLoggingConfiguration_getInstance().direct_1.get_formatter_wk0jxb_k$().formatMessage_52asgz_k$(loggingEvent);
        this.logFormattedMessage_32jwnf_k$(loggingEvent, it);
      }
    }
    initMetadataForClass($, 'FormattingAppender');
    FormattingAppenderClass = $;
  }
  return FormattingAppenderClass;
}
//region block: exports
export {
  FormattingAppender as FormattingAppender1iqfktuucnzpr,
};
//endregion

//# sourceMappingURL=Appender.mjs.map
